import { ReactKit } from '@team/react';
import { Drawer } from 'vaul';
import { Root } from './components/root';
import { Content } from './components/content';
import { Handle } from './components/handle';
import { Header } from './components/header';
import { Overlay } from './components/overlay';

export const Sheet = ReactKit.createCompoundComponent(Root, {
  Trigger: Drawer.Trigger,
  Close: Drawer.Close,
  Portal: Drawer.Portal,
  Overlay,
  Content,
  Handle,
  Header,
  Title: Drawer.Title,
  Description: Drawer.Description,
});

Sheet.displayName = 'Sheet';
Sheet.Trigger.displayName = 'SheetTrigger';
// Sheet.Portal.displayName = 'SheetPortal';
Sheet.Overlay.displayName = 'SheetOverlay';
Sheet.Content.displayName = 'SheetContent';
Sheet.Handle.displayName = 'SheetHandle';
Sheet.Header.displayName = 'SheetHeader';
Sheet.Title.displayName = 'SheetTitle';
Sheet.Description.displayName = 'SheetDescription';
